
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/footerItems/policies/terms",
      function () {
        return require("private-next-pages/footerItems/policies/terms.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/footerItems/policies/terms"])
      });
    }
  